<div dashboard="dashboard.options" template-url="views/dashboard_template.html" ng-if="dashboard.loadedMapsApi"></div>
